module.exports = __webpack_public_path__ + "static/media/movio.386eb627.jpg";